// local-file-store.js — IndexedDB 封装，持久化 FileSystemFileHandle
// 用于 /list 和 /story 两端共享，支持保存原始文件后写回本地

const DB_NAME = 'localFileStore';
const STORE_NAME = 'handles';
const KEY = 'currentFileHandle';

function openDB() {
  return new Promise(function(resolve, reject) {
    var request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = function() {
      request.result.createObjectStore(STORE_NAME);
    };
    request.onsuccess = function() { resolve(request.result); };
    request.onerror = function() { reject(request.error); };
  });
}

export async function saveFileHandle(handle) {
  var db = await openDB();
  return new Promise(function(resolve, reject) {
    var tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).put(handle, KEY);
    tx.oncomplete = function() { db.close(); resolve(); };
    tx.onerror = function() { db.close(); reject(tx.error); };
  });
}

export async function getFileHandle() {
  var db = await openDB();
  return new Promise(function(resolve, reject) {
    var tx = db.transaction(STORE_NAME, 'readonly');
    var request = tx.objectStore(STORE_NAME).get(KEY);
    request.onsuccess = function() { db.close(); resolve(request.result || null); };
    request.onerror = function() { db.close(); reject(request.error); };
  });
}
